
/* eslint-disable global-require, import/no-dynamic-require */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zipObject from 'lodash/zipObject';

import getUser from '~~/common/js/universal/getters/user';
import { DEFAULT_LOCALE, LOCALES } from '~~/common/js/constants/i18n';

Vue.use(VueI18n);

const getUserLocale = ({ req, store }) => {
  let locale = DEFAULT_LOCALE;
  if (req) {
    // we have the request object, so we can get the locale from the cookie
    const user = getUser(req);
    locale = user.get('language') || DEFAULT_LOCALE;
  } else {
    // we're probably on the client, so the locale should already be in store
    // for backwards compatiblity locale from root store
    // is supported as fallback if global store hasn't been added to the projects
    locale = store.state.global ? store.state.global.locale : store.state.locale;
  }
  return locale;
};

/**
 * This module provides the VueI18n plugin set up with
 * both common and project-specific translations
 */
export default (context) => {
  const { app } = context;
  const locale = getUserLocale(context);
  const locales = LOCALES.filter((lcl) => lcl === locale || locale === DEFAULT_LOCALE);
  const messages = zipObject(locales, locales.map((lcl) => {
    const commonLocale = require(`~~/common/locales/${lcl}.json`);
    const projectLocale = require(`~/locales/${lcl}.json`);
    return { ...commonLocale, ...projectLocale };
  }));
  app.i18n = new VueI18n({
    locale,
    fallbackLocale: DEFAULT_LOCALE,
    messages,
  });
};
